import React from "react";
import { styles } from "./commonStyles";

interface FieldWrapperProps {
    fieldLabel: string | undefined;
    children: React.ReactNode;
    testId?: string;
    customValueStyle?: React.CSSProperties;
}

/**
 * A reusable wrapper component for all field display components
 * Handles the common layout pattern with conditional label display and grid column spanning
 */
export const FieldWrapper = ({ 
    fieldLabel, 
    children, 
    testId, 
    customValueStyle 
}: FieldWrapperProps): JSX.Element => {
    return (
        <>
            <div style={{ ...styles.labelStyle, display: fieldLabel ? "block" : "none" }}>
                {fieldLabel}
            </div>
            <div
                data-testid={testId || fieldLabel}
                style={{
                    ...styles.valueStyle,
                    ...customValueStyle
                }}
            >
                {children}
            </div>
        </>
    );
};